import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../Model/Product.model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'productFilter',
  standalone: false
})
export class ProductFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(products: Product[], searchTerm: string, field: string): Product[] {
    if (!products || !searchTerm) return products;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return products.filter(product => this.matchesSearchTerm(product, lowerSearchTerm));
  }

  private matchesSearchTerm(product: Product, term: string): boolean {
    const fieldsToCheck: (keyof Product | { dateField: keyof Product })[] = [
      'skuCode',
      'skuDescription',
      'marketCompanyName',
      'brandCompanyName',
      'marketLabel',
      'categoryLabel',
      'localStatus',
      'isInnovation',
      'priceBandLabel',
      'brandName',
      'brandQualityName',
      'codeEan13',
      'commercialName',
      'size',
      { dateField: 'applicationDate' },
    ];

    return fieldsToCheck.some(field => {
      if (typeof field === 'string') {
        const value = product[field];
        return value != null && value.toString().toLowerCase().includes(term);
      }

      const dateValue = product[field.dateField];
      if (!dateValue) return false;

      const formattedDate = this.datePipe.transform(dateValue as Date, 'MMMM dd, yyyy');
      return formattedDate?.toLowerCase().includes(term) || false;
    });
  }
}
